import React from 'react';

import { template } from 'lodash';
import { EmptyBar } from 'screens/analytics/commonComponents';
import styled from 'styled-components';
import { StyledGrid } from 'styles/common';
import { baseTheme } from 'themes/clients/baseTheme';

import { ProgressBar } from 'uiToolkitV1/ProgressBar';

const compiled = template(
  '(Excelled: ${ EXCELLED.percentage }%, Skilled: ${SKILLED.percentage}%, Building: ${BUILDING.percentage}%, Starting: ${STARTING.percentage}%, Not Critical: ${NOT_CRITICAL.percentage}%)'
);

const ProgressCell = ({ progress }) => {
  // const progressPercentageString = progress ? compiled(progress) : '';

  if (progress === null) {
    return (
      <StyledGrid container justify="center" alignItems="center">
        <EmptyBar />
      </StyledGrid>
    );
  }

  return (
    <ProgressContainer>
      <ProgressBar value={progress} size="large" color={baseTheme.colors.functional['91CA7D']} showPercentage />
      {/* <div style={{ marginTop: '0.5rem' }}>
        <Typography12 customColor={theme.palette.text.dark1}>
          {progressPercentageString}
        </Typography12>
      </div> */}
    </ProgressContainer>
  );
};

const ProgressContainer = styled.div`
  max-width: 18rem;
  margin: 0 auto;
`;

export default ProgressCell;
